// extracted by mini-css-extract-plugin
export default {"title":"poc_title__mmyig","wrapper":"poc_wrapper__+mfyL","nextBtn":"poc_nextBtn__lm4cz"};